<h1 style="text-align: center;" mat-dialog-title ><span *ngIf="!data.Remove" > Add to</span>   <span *ngIf="data.Remove" > Remove from </span> Inventory </h1>
<div mat-dialog-actions class="actions">
    <ng-container >
        <div style="width: 100%; margin: 5px;">
        </div>

        <mat-form-field  style="margin: auto" class="example-full-width">
          <mat-label>Quantity</mat-label>
          <input style=" margin: 5px;;" matInput [(ngModel)]="data.Quantity"> 
        </mat-form-field>
    </ng-container>
    <div style="width: 100%; margin: 5px;">
        <button style="float: right" mat-raised-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>Cancel</button>

        <button style="float: right; margin-right: 5px;" mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial> <span *ngIf="!data.Remove" > Add </span> <span *ngIf="data.Remove" > Remove </span></button>
    </div>
</div>